import React from "react";
import { Toast as RSToast, ToastBody, Row, Col, Button } from "reactstrap";

import "./Toast.scss";
import useEffectOnce from "../hooks/useEffectOnce";
import { useStoreActions } from "easy-peasy";

const Toast = ({ timestamp, color, message, ...props }) => {
  const removeToast = useStoreActions(actions => actions.toasts.removeToast);

  useEffectOnce(() => {
    setTimeout(() => {
      removeToast(timestamp);
    }, 4000);
  });

  return (
    <RSToast className="my-toast" {...props}>
      <ToastBody className="my-toast-body">
        <Row className="align-items-center">
          <Col xs={1}>
            <svg
              className={`rounded text-${color} mr-2`}
              width="20"
              height="20"
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="xMidYMid slice"
              focusable="false"
              role="img"
            >
              <rect fill="currentColor" width="100%" height="100%"></rect>
            </svg>
          </Col>
          <Col>
            <span className="align-middle">{message || "blank content"}</span>
          </Col>
          <Col xs={2}>
            <Button close onClick={() => removeToast(timestamp)} />
          </Col>
        </Row>
      </ToastBody>
    </RSToast>
  );
};

export default Toast;
